import React from 'react';
import { DropTarget } from 'react-dnd';
import { debounce as _debounce } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import LeadCard from 'components/layout/lead/LeadCard';

const cardTarget = {
  drop(props, monitor, component) {
    const { id: draggedId } = monitor.getItem();
    const lead = component.findCard(draggedId);

    if (lead.currentStage !== component.props.stage.id) {
      component.moveCard(draggedId, component.props.stage.id);
    }
  },
};

@DropTarget('card', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))
class LeadStage extends React.Component {
  moveCard = (id, stageId) => {
    const { moveLead } = this.props;
    moveLead(id, stageId);
  };

  findCard = id => {
    const { leads } = this.props;
    const card = leads.data.list.filter(c => c.id === id)[0];

    return {
      card,
      index: leads.data.list.indexOf(card),
    };
  };

  getLeads = () => {
    const { index, stage, leads } = this.props;

    const res = [];
    leads.data.list.map(lead => {
      if ((!lead.current_stage && index === 0) || stage.id === lead.current_stage) {
        res.push(lead);
      }
    });

    return res;
  };

  onClick = (e, lead) => {
    if (!this.delayedClick) {
      this.delayedClick = _debounce(this.doSingleClick, 300);
    }
    if (this.clickedOnce) {
      this.delayedClick.cancel();
      this.clickedOnce = false;

      this.doDoubleClick(e, lead);
    } else {
      this.delayedClick(e, lead);
      this.clickedOnce = true;
    }
  };

  // if a lead is clicked once, open the slideout
  doSingleClick = (e, lead) => {
    this.clickedOnce = undefined;

    const { showSlideoutDetails } = this.props;
    showSlideoutDetails(lead);
  };

  // if a lead is clicked twice, navigate to the lead
  doDoubleClick = (e, lead) => {
    const { appIntl, type, navToLead } = this.props;
    const detailsUrl = appIntl.urlPrefix + 'account/' + type + 's/' + lead.id;

    navToLead(detailsUrl);
  };

  render() {
    const { appIntl, type, width, stage, leadCount, connectDropTarget, isOver, messages, selectedLeadId } = this.props;

    const stageLeads = this.getLeads();

    return connectDropTarget(
      <div
        style={{ width: width + '%' }}
        class={'pipeline-stage-list ' + (isOver ? 'pipeline-stage-lead-dragging ' : '')}
      >
        <div class="pipeline-stage-view">
          <h2 class="pipeline-stage-header" style={{ position: 'initial' }}>
            {getNameInCurrentLanguage(stage.name, appIntl)} ({leadCount})
          </h2>

          <div class="padding-10">
            {stageLeads.map(lead => {
              return (
                <LeadCard
                  key={lead.id}
                  moveCard={this.moveCard}
                  findCard={this.findCard}
                  lead={lead}
                  onClick={this.onClick}
                  messages={messages}
                  selected={lead.id === selectedLeadId}
                  type={type}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
LeadStage.defaultProps = {
  onLeadClick: () => {},
};

export default LeadStage;
